module.exports = __webpack_public_path__ + "img/ico-more.8ecc3e18.svg";